<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->

<div class="work-heading" [ngClass]="{ disabled: isDisabled }">{{ appStrings.WORKDAYS }}</div>
<tp-day-chip-list
	[dayChips]="workdayChips$"
	[disabled]="isDisabled"
	(chipClick)="changeWorkDay($event)"
></tp-day-chip-list>
